(function(){
    'use strict'; 
    angular.module('Filters').filter('getUniqueValues', function(){
        return function(array){ 
            const  uniqueArray = [];
            for(let i = 0; i < array.length; i++) {
                const arrayData = array[i];
                const found = uniqueArray.filter(data=>{
                    return angular.equals(arrayData, data);
                });

                if(found.length == 0) {
                    uniqueArray.push(arrayData);
                }
            }
            return uniqueArray;
        }
    });
})();


// WEBPACK FOOTER //
// ./js/filters/getUniqueValues.js